module.exports = __webpack_public_path__ + "static/media/no-content.7430029f.png";